import { useAppContext } from '@/App';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useState } from 'react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import useStaffPresence from '@/hooks/useStaffPresence';

export default function AppShell({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  // Authorized staff count as available to website visitors anywhere in the
  // portal, not only while the Website Messages inbox is open.
  useStaffPresence();

  return (
    <div className="flex h-screen overflow-hidden bg-white">
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:w-[260px] lg:flex-shrink-0">
        <Sidebar />
      </div>

      {/* Mobile Sidebar */}
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="p-0 w-[260px]">
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Topbar onMenuClick={() => setMobileOpen(true)} />
        <main className="flex-1 overflow-y-auto bg-[#F7F8FA]">
          <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
